/**
 * GLSL code for dynamically swizzling texture color channels for debug display.
 * @module
 */

export const ChannelVisualizationFragmentShader = `
varying vec2 vUv;

uniform sampler2D map;

// Values 0-3 in this vector pick the channel to use from map for that gl_FragColor output channel. Value -1 will set that channel to constant 1.
uniform vec4 channels;

float pickChannel(vec4 col, float channel) {
  if (abs(channel) < 0.001) {
    return col[0];
  }
  if (abs(channel - 1.0) < 0.001) {
    return col[1];
  }
  if (abs(channel - 2.0) < 0.001) {
    return col[2];
  }
  if (abs(channel - 3.0) < 0.001) {
    return col[3];
  }
  return 1.0;
}

void main() {
  vec4 col = texture2D(map, vUv);
  gl_FragColor = vec4(pickChannel(col, channels[0]), pickChannel(col, channels[1]), pickChannel(col, channels[2]), pickChannel(col, channels[3]));
}
`;
